import ModalVideo from "react-modal-video";

export default function Index({
  videoId,
  activeVideo,
  closeVideoModal,
  isVideoModalOpen,
}) {
  return (
    <ModalVideo
      autoplay
      channel="youtube"
      videoId={videoId}
      isOpen={isVideoModalOpen}
      onClose={closeVideoModal}
    />
  );
}
